import Marquee from "react-fast-marquee";

const items = ["Ground Maintenance", "Commercial", "Domestic", "Lawn Care", "Hedge Work", "Garden Clearance", "North East England"];

export const EditorialMarquee = () => {
  return (
    <section className="bg-brand-ink py-10 md:py-16 border-y border-white/10 overflow-hidden">
      <Marquee speed={45} gradient={false} autoFill>
        {items.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display uppercase text-stroke text-6xl md:text-8xl mx-8">{t}</span>
            <span className="w-3 h-3 rounded-full bg-brand-orange mx-8" />
          </div>
        ))}
      </Marquee>
    </section>
  );
};
